import { useState, useEffect } from 'react';
import { totalCountEvent } from 'services/generalServices';
import { listLeadStages } from 'services/Settings';
import { extractPracticeAreaIds } from 'utils/utils';

export default function useLeadStages(practiceAreaIds = []) {
  const [leadStages, setLeadStages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const loadLeadStages = (practiceAreaIds = []) => {
    setIsLoading(true);
    totalCountEvent('lead-stage')
      .then((response) => {
        listLeadStages(
          response.data,
          '',
          '',
          'ACTIVE',
          { practice_area: extractPracticeAreaIds(practiceAreaIds), show_unassigned_pa_column: true },
          ''
        )
          .then((res) => setLeadStages(res.data?.lead_stage || []))
          .catch((error) => console.error(error))
          .finally(() => setIsLoading(false));
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    loadLeadStages(practiceAreaIds);
  }, []);

  return { leadStages, isLeadStageLoading: isLoading, loadLeadStages };
}
